import { render, staticRenderFns } from "./MilestoneInvoice.vue?vue&type=template&id=5f552719"
import script from "./MilestoneInvoice.vue?vue&type=script&lang=js"
export * from "./MilestoneInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports